// import "core-js/stable";
// import "regenerator-runtime/runtime";
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Button, Menu, FormModel, Input, Icon, message, Spin, Layout, Row, Col, Divider, Collapse, Tree, Table, Tabs, Modal, Radio, Select, Popconfirm, Upload, InputNumber, Dropdown, Switch, Slider, List,Pagination,DatePicker,ConfigProvider,AutoComplete } from 'ant-design-vue'
import axiosConfig from './axios-config'
import vcolorpicker from 'vcolorpicker'
import JsonExcel from "vue-json-excel";
import global from './utils/Global';
import VueParticles from 'vue-particles'
//引入图片查看器
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';

Vue.config.productionTip = false

Vue.component(Button.name, Button)
Vue.component(Menu.name, Menu)
Vue.component(Menu.Item.name, Menu.Item);
Vue.component(Menu.SubMenu.name, Menu.SubMenu);
Vue.component(FormModel.name, FormModel);
Vue.component(FormModel.Item.name, FormModel.Item);
Vue.component(Input.name, Input);
Vue.component(Icon.name, Icon);
Vue.component(Spin.name, Spin);
Vue.component(Layout.name, Layout);
Vue.component(Layout.Header.name, Layout.Header);
Vue.component(Layout.Content.name, Layout.Content);
Vue.component(Layout.Sider.name, Layout.Sider);
Vue.component(Col.name, Col);
Vue.component(Row.name, Row);
Vue.component(Divider.name, Divider);
Vue.component(Collapse.name, Collapse);
Vue.component(Collapse.Panel.name, Collapse.Panel);
Vue.component(Tree.name, Tree);
Vue.component(Table.name, Table);
Vue.component(Tabs.name, Tabs);
Vue.component(Tabs.TabPane.name, Tabs.TabPane);
Vue.component(Radio.name, Radio);
Vue.component(Radio.Group.name, Radio.Group);
Vue.component(Radio.Button.name, Radio.Button);
Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
Vue.component(Popconfirm.name, Popconfirm);
Vue.component(Upload.name, Upload);
Vue.component(Upload.Dragger.name, Upload.Dragger);
Vue.component(InputNumber.name, InputNumber);
Vue.component(Input.Group.name, Input.Group);
Vue.component(Input.TextArea.name, Input.TextArea);
Vue.component(Dropdown.name, Dropdown);
Vue.component(Switch.name, Switch);
Vue.component(Slider.name, Slider);
Vue.component(List.name, List);
Vue.component(List.Item.name, List.Item);
Vue.component(Pagination.name, Pagination);
Vue.component(DatePicker.name, DatePicker);
Vue.component(ConfigProvider.name, ConfigProvider);
Vue.component(AutoComplete.name, AutoComplete);

message.config({
  duration: 2,
  maxCount: 1,
});
Vue.prototype.$message = message;
Vue.component("downloadExcel", JsonExcel);

Vue.prototype.$global = global;

Vue.use(axiosConfig)
Vue.use(Modal)
Vue.use(vcolorpicker)
Vue.use(VueParticles)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
